/**
 * The embed hash from a share url, for `queryMeta`. Returns "" rather than
 * throwing when there is nothing to read: `query.share_url` is optional on
 * every reporting API response, and the pacing screen is the only consumer
 * that reads `embedHash` at all — and it discards it.
 *
 * The Looker transport derives the same hash from `IQuery.share_url` and
 * throws when it is missing; there the field is guaranteed, so its absence is
 * a broken query rather than an omitted key.
 */
export const toEmbedHash = (shareUrl) => {
    if (!shareUrl) {
        return "";
    }
    try {
        const [hash] = new URL(shareUrl).pathname.match(/(?<=\/x\/).*/) || [];
        return hash || "";
    }
    catch {
        return "";
    }
};
//# sourceMappingURL=query.js.map